import { TipoLocalitaEstera1 } from 'server/schema/integrations/pdnd/schema/schemas';

export function getCitizenForeignAddress(
  foreignLocation?: TipoLocalitaEstera1
): string | undefined {
  if (!foreignLocation?.indirizzoEstero) {
    return undefined;
  }
  return [
    foreignLocation?.indirizzoEstero?.toponimo?.denominazione,
    foreignLocation?.indirizzoEstero?.toponimo?.numeroCivico,
    foreignLocation?.indirizzoEstero?.cap
  ]
    .filter(Boolean)
    .join(', ');
}
